import { create } from "zustand";
import CommunicationManager from "../Helper/CommunicationManager";
import { HttpFrontendToolService } from "../Services/http.clients/http.frontend.tool.client";

/**
 * Frontend tool executions (`bot.tool.execute`): the AI agent asks the host
 * app to run a handler registered via Gleap.registerAgentTool(name, handler).
 * The handler runs immediately; when the SDK posts the result back, we deliver
 * it to the server, where the agent's tool call is blocking on it.
 *
 * "Ask before final execution" is handled entirely by the agent (it asks the
 * user to confirm in chat before running) — there is no separate confirm
 * button here.
 */
interface FrontendToolState {
  handleExecutionRequest: (actionData: any) => void;
  handleSdkResult: (data: {
    toolCallId: string;
    name: string;
    result: string;
  }) => void;
}

export const useFrontendToolStore = create<FrontendToolState>()(() => ({
  handleExecutionRequest: (actionData: any) => {
    const toolCallId = actionData?.toolCallId;
    const name = actionData?.name;
    if (!toolCallId || !name) {
      return;
    }

    // Execute in the host app right away.
    CommunicationManager.getInstance().sendMessage({
      name: "frontend-tool-execute",
      data: {
        toolCallId,
        name,
        params: actionData.params ?? {},
      },
    });
  },

  handleSdkResult: (data) => {
    if (!data?.toolCallId) {
      return;
    }

    // Deliver to the awaiting agent. Errors are already folded into the
    // result string by the SDK; a failed POST simply lets the agent's
    // timeout messaging take over.
    HttpFrontendToolService.getInstance()
      .deliverResult({ toolCallId: data.toolCallId, result: data.result })
      .catch(() => {});
  },
}));
